import Loadable from '../../react-loadable';
import { tagClsPrefix } from '../../constants/index';
import { TagType } from './types';

const Tag = Loadable({ name: 'Tag', loader: () => import(
  /* webpackChunkName: "ui_commont" */
  './Tag') }) as TagType;

Tag.defaultProps = {
  prefixCls: tagClsPrefix,
};

export type { TagProps } from './types';

export default Tag;